import lazyGettext from 'js-utils/lazy-gettext';
import omitBy from 'lodash/omitBy';
import PropTypes from 'prop-types';
import { datePropType } from '../utils/propTypes';
import DayPickerRangeController from 'react-dates/lib/components/DayPickerRangeController';
export var ORANGE_COLOR = 'orange';
export var BLUE_COLOR = 'blue';
export var COLOR_PROP = [ORANGE_COLOR, BLUE_COLOR];
export var COLOR_PROP_TYPE = PropTypes.oneOf([ORANGE_COLOR, BLUE_COLOR]);
export var START_DATE = 'startDate';
export var END_DATE = 'endDate';
export var INITIAL_FOCUS = [START_DATE, END_DATE];
export var RANGE_VALUE = {
  startDate: datePropType,
  endDate: datePropType
};
export var RANGE_VALUE_PROPTYPE = PropTypes.shape(RANGE_VALUE);
export var DAY_PICKER_RANGE_CONTROLLER_PROP_TYPES = omitBy(DayPickerRangeController.propTypes, // Remove trap prop set by `prop-types-exact/forbidExtraProps`
// since we have more props specific to our components.
function (_, key) {
  return key.startsWith('prop-types-exact');
}); // i18n Phrases
// Based on https://github.com/airbnb/react-dates/blob/master/src/defaultPhrases.js

export var localizedPhrases = {
  calendarLabel: lazyGettext('Calendar'),
  closeDatePicker: lazyGettext('Close'),
  focusStartDate: lazyGettext('Interact with the calendar and add the check-in date for your trip.'),
  clearDate: lazyGettext('Clear Date'),
  clearDates: lazyGettext('Clear Dates'),
  jumpToPrevMonth: lazyGettext('Move backward to switch to the previous month.'),
  jumpToNextMonth: lazyGettext('Move forward to switch to the next month.'),
  keyboardShortcuts: lazyGettext('Keyboard Shortcuts'),
  showKeyboardShortcutsPanel: lazyGettext('Open the keyboard shortcuts panel.'),
  hideKeyboardShortcutsPanel: lazyGettext('Close the shortcuts panel.'),
  openThisPanel: lazyGettext('Open this panel.'),
  enterKey: lazyGettext('Enter key'),
  leftArrowRightArrow: lazyGettext('Right and left arrow keys'),
  upArrowDownArrow: lazyGettext('up and down arrow keys'),
  pageUpPageDown: lazyGettext('page up and page down keys'),
  homeEnd: lazyGettext('Home and end keys'),
  escape: lazyGettext('Escape key'),
  questionMark: lazyGettext('Question mark'),
  selectFocusedDate: lazyGettext('Select the date in focus.'),
  moveFocusByOneDay: lazyGettext('Move backward (left) and forward (right) by one day.'),
  moveFocusByOneWeek: lazyGettext('Move backward (up) and forward (down) by one week.'),
  moveFocusByOneMonth: lazyGettext('Switch months.'),
  moveFocustoStartAndEndOfWeek: lazyGettext('Go to the first or last day of a week.'),
  returnFocusToInput: lazyGettext('Return to the date input field.'),
  keyboardNavigationInstructions: lazyGettext('Press the down arrow key to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.'),
  chooseAvailableStartDate: function chooseAvailableStartDate(_ref) {
    var date = _ref.date;
    return lazyGettext('Choose %(date)s as your check-in date. It’s available.', {
      date: date
    });
  },
  chooseAvailableEndDate: function chooseAvailableEndDate(_ref2) {
    var date = _ref2.date;
    return lazyGettext('Choose %(date)s as your check-out date. It’s available.', {
      date: date
    });
  },
  chooseAvailableDate: function chooseAvailableDate(_ref3) {
    var date = _ref3.date;
    return lazyGettext('Select this date. %(date)s', {
      date: date
    });
  },
  dateIsUnavailable: function dateIsUnavailable(_ref4) {
    var date = _ref4.date;
    return lazyGettext('Not available. %(date)s', {
      date: date
    });
  },
  dateIsSelected: function dateIsSelected(_ref5) {
    var date = _ref5.date;
    return lazyGettext('Selected. %(date)s', {
      date: date
    });
  },
  dateIsSelectedAsStartDate: function dateIsSelectedAsStartDate(_ref6) {
    var date = _ref6.date;
    return lazyGettext('Selected as start date. %(date)s', {
      date: date
    });
  },
  dateIsSelectedAsEndDate: function dateIsSelectedAsEndDate(_ref7) {
    var date = _ref7.date;
    return lazyGettext('Selected as end date. %(date)s', {
      date: date
    });
  }
};